import { lazy, Suspense } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { SiteLayout } from "@/components/site/site-layout";
import { Hero } from "@/components/sections/hero";
import { ServicesExplorer } from "@/components/sections/services-explorer";

// Lazy-load below-the-fold landing page sections for ultra-fast initial mobile FCP/LCP
const DigitalMarketplace = lazy(() =>
  import("@/components/sections/digital-marketplace").then((m) => ({ default: m.DigitalMarketplace })),
);
const IdeaToSuccess = lazy(() =>
  import("@/components/sections/idea-to-success").then((m) => ({ default: m.IdeaToSuccess })),
);
const WorkProcess = lazy(() =>
  import("@/components/sections/work-process").then((m) => ({ default: m.WorkProcess })),
);
const Brands = lazy(() =>
  import("@/components/sections/brands").then((m) => ({ default: m.Brands })),
);
const Services = lazy(() =>
  import("@/components/sections/services").then((m) => ({ default: m.Services })),
);
const ProductsPricing = lazy(() =>
  import("@/components/sections/products-pricing").then((m) => ({ default: m.ProductsPricing })),
);
const Portfolio = lazy(() =>
  import("@/components/sections/portfolio").then((m) => ({ default: m.Portfolio })),
);
const Testimonials = lazy(() =>
  import("@/components/sections/testimonials").then((m) => ({ default: m.Testimonials })),
);
const Faq = lazy(() =>
  import("@/components/sections/faq").then((m) => ({ default: m.Faq })),
);
const BlogPreview = lazy(() =>
  import("@/components/sections/blog-preview").then((m) => ({ default: m.BlogPreview })),
);
const CTABanner = lazy(() =>
  import("@/components/sections/cta-banner").then((m) => ({ default: m.CTABanner })),
);

export const Route = createFileRoute("/")({
  component: Index,
  head: () => ({
    meta: [
      { title: "CoderLity — Digital Agency, SaaS, ERP & Hosting" },
      { name: "description", content: "CoderLity is a full-stack digital agency: web & mobile apps, SaaS, ERP, POS, AI automation, hosting, domains and marketing — all in one premium partner." },
      { property: "og:title", content: "CoderLity — Premium Digital Agency" },
      { property: "og:description", content: "Web, SaaS, ERP, POS, hosting and AI growth — under one premium roof." },
      { property: "og:url", content: "https://coderlity.com" },
    ],
    links: [{ rel: "canonical", href: "https://coderlity.com" }],
  }),
});

function Index() {
  return (
    <SiteLayout>
      <Hero />
      <ServicesExplorer />
      <Suspense fallback={<div className="py-12" />}>
        <DigitalMarketplace />
      </Suspense>
      <Suspense fallback={<div className="py-12" />}>
        <IdeaToSuccess />
      </Suspense>
      <Suspense fallback={<div className="py-12" />}>
        <WorkProcess />
      </Suspense>
      <Suspense fallback={<div className="py-12" />}>
        <Brands />
      </Suspense>
      <Suspense fallback={<div className="py-12" />}>
        <Services />
      </Suspense>
      <Suspense fallback={<div className="py-12" />}>
        <ProductsPricing />
      </Suspense>
      <Suspense fallback={<div className="py-12" />}>
        <Portfolio />
      </Suspense>
      <Suspense fallback={<div className="py-12" />}>
        <Testimonials />
      </Suspense>
      <Suspense fallback={<div className="py-12" />}>
        <Faq />
      </Suspense>
      <Suspense fallback={<div className="py-12" />}>
        <BlogPreview />
      </Suspense>
      <Suspense fallback={<div className="py-12" />}>
        <CTABanner />
      </Suspense>
    </SiteLayout>
  );
}
